import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Eyebrow, Heading, Text } from './Text';
import { Button } from './Button';
import './StudyCard.css';

/**
 * Figma Studies card — marketing study teaser (dark|light).
 */
export function StudyCard({
  title,
  description,
  eyebrow = 'Study',
  href,
  to,
  tone = 'light',
  ctaLabel = 'Learn more',
  className = '',
}) {
  const body = (
    <>
      <Eyebrow>{eyebrow}</Eyebrow>
      <Heading level={3} className="onyx-study-card__title">{title}</Heading>
      {description ? (
        <Text variant="body-m" className="onyx-study-card__desc">{description}</Text>
      ) : null}
      <Button variant={tone === 'dark' ? 'secondary' : 'primary'} size="large" chevron>
        {ctaLabel}
      </Button>
    </>
  );

  const cls = [
    'onyx-study-card',
    `onyx-study-card--${tone}`,
    className,
  ].filter(Boolean).join(' ');

  if (to) {
    return (
      <Link to={to} className={cls} data-testid="onyx-study-card">
        {body}
      </Link>
    );
  }
  if (href) {
    return (
      <a href={href} className={cls} data-testid="onyx-study-card">
        {body}
      </a>
    );
  }
  return (
    <article className={cls} data-testid="onyx-study-card">
      {body}
    </article>
  );
}

StudyCard.propTypes = {
  title: PropTypes.node.isRequired,
  description: PropTypes.node,
  eyebrow: PropTypes.node,
  href: PropTypes.string,
  to: PropTypes.string,
  tone: PropTypes.oneOf(['light', 'dark']),
  ctaLabel: PropTypes.node,
  className: PropTypes.string,
};

/**
 * Figma headline comp 1 | 2
 */
export function SectionHeadline({
  variant = '1',
  title,
  description,
  className = '',
}) {
  return (
    <header
      className={[
        'onyx-section-headline',
        `onyx-section-headline--${variant}`,
        className,
      ].filter(Boolean).join(' ')}
      data-testid="onyx-section-headline"
    >
      <Heading level={variant === '2' ? 3 : 2}>{title}</Heading>
      {description ? <Text variant="body-l">{description}</Text> : null}
    </header>
  );
}

SectionHeadline.propTypes = {
  variant: PropTypes.oneOf(['1', '2']),
  title: PropTypes.node.isRequired,
  description: PropTypes.node,
  className: PropTypes.string,
};

export default StudyCard;
